// #ux-redesign-start: Checkbox primitive (Paso 5 — Auth redesign)
// Reemplaza el `<input type="checkbox">` + `.form-check-sign` custom del
// template legacy now-ui-dashboard por una primitiva del DS:
//   - Caja custom dibujada vía CSS + SVG checkmark
//   - Tematizada por tokens (light + dark)
//   - Estado de error
//   - Focus visible vía focus ring del DS
//   - Compatible con react-hook-form v5 (innerRef = register())
//
// PORTABILIDAD: trasplantable a Web-Patients sin cambios.
//
// USO con react-hook-form v5:
//   const { register, errors } = useForm({ validationSchema });
//   <Checkbox
//     name="terms"
//     label="Ich akzeptiere die AGB"
//     innerRef={register}
//     error={errors.terms?.message}
//   />
//
// USO controlado:
//   <Checkbox checked={remember} onChange={(e) => setRemember(e.target.checked)} label="Keep me logged in" />
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';

let cbIdCounter = 0;
const nextId = () => `ds-cb-${++cbIdCounter}`;

const Checkbox = React.forwardRef(({
  id,
  name,
  label,
  error,
  disabled = false,
  className = '',
  innerRef,
  children,
  ...rest
}, ref) => {
  const fieldId = React.useMemo(() => id || nextId(), [id]);
  const hasError = Boolean(error);

  const wrapperClasses = [
    'ds-checkbox',
    hasError ? 'ds-checkbox--error' : '',
    disabled ? 'ds-checkbox--disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={wrapperClasses}>
      <label htmlFor={fieldId} className="ds-checkbox__label">
        <input
          id={fieldId}
          name={name}
          type="checkbox"
          ref={innerRef || ref}
          disabled={disabled}
          aria-invalid={hasError || undefined}
          className="ds-checkbox__input"
          {...rest}
        />
        <span className="ds-checkbox__box" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 8.5 6.5 12 13 4.5" />
          </svg>
        </span>
        <span className="ds-checkbox__text">{label || children}</span>
      </label>
      {error && <div className="ds-checkbox__helper">{error}</div>}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.node,
  error: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  innerRef: PropTypes.any,
  children: PropTypes.node,
};

export default Checkbox;
// #ux-redesign-end
